export const newsIcons: { [key: string]: string } = {
  "paper": "📋",
  "school": "🏫",
  "work": "💼",
  "conference": "🛫",
  "pin": "📌",
}

export const news = [
  { icon: "conference", line: "Heading to UIST 2026 in Detroit, appearing at the workshop and poster!", date: "Nov 2026" },
  { icon: "school", line: "Started my Ph.D. in Computer Science at Purdue University 🇺🇸", date: "Aug 2026" },
  { icon: "paper", line: "Two posters have been accepted at UIST Adjunct 2026 📋", date: "Aug 2026" },
  { icon: "school", line: "Selected for the Korean Government Scholarship Program for Study Overseas (KGSPSO) 🇰🇷", date: "Aug 2026" },
  { icon: "school", line: "Received the Ross Fellowship with Herbold Scholarship from Purdue University 🏅", date: "Apr 2026" },
  { icon: "school", line: "Graduated from KAIST with a B.S. in School of Computing and Industrial Design (+Summa Cum Laude 🎓)", date: "Feb 2026" },
  { icon: "conference", line: "Heading to UIST 2025 in Korea 🇰🇷 appearing at the workshop and poster!", date: "Sep 2025" },
  { icon: "paper", line: "My third paper has been accepted at UIST Adjunct 2025 📋", date: "Aug 2025" },
  { icon: "work", line: "Joined KIXLAB (again!) as an undergrad intern researcher 💼", date: "Jul 2025" },
  { icon: "conference", line: "Heading to CHI 2025 in Japan 🇯🇵", date: "Apr 2025" },
  { icon: "paper", line: "My second paper has been accepted at CHI EA 2025 📋", date: "Feb 2025" },
  { icon: "school", line: "Selected for 2025 Undergrad Research Program 🏅", date: "Dec 2024" },
  { icon: "work", line: "Joined Makelab as an undergrad intern researcher 💼", date: "Aug 2024" },
  { icon: "conference", line: "Attending CHI 2024 in Hawaii 🌴", date: "May 2024" },
  { icon: "paper", line: "My first paper has been accepted at CHI 2024 📋", date: "Feb 2024" },
  { icon: "school", line: "Started KAIST-NYU minor at New York University 🗽", date: "Jan 2024" },
  { icon: "work", line: "Joined KIXLAB as an undergrad intern researcher 💼", date: "Jul 2023" },
]

export const newsFixed = [
  // { icon: "pin", line: "PhD applicant for 2026, with a interest in HCI", },
]

